import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MAX_QUANTITY } from '../shared/cart';
import { toggleCreditOnCartItem } from '../modules/computed_cart';
import { removeCartProduct } from '../modules/cart_actions';

class ModalMiniCartItem extends Component {

  constructor(props) {
    super(props);
  }


  render() {
    let computedCart = this.props.computedCart;
    let product = this.props.product;
    let hasPromo = (computedCart.promo_items.length > 0 && computedCart.promo_items[this.props.arrayItem] !== null) ? true : false;

    // handle null/undefined values in cart (position 0, reserved for FS)
    if (this.props.arrayItem === -1 || !product) {
      return <tr />
    }

    let salePrice = parseFloat(product.sale_price * product.quantity).toFixed(2);
    let eNewPrice = '';
    if ((hasPromo && computedCart.promo) || product.credit || (!product.credit && product.bundle_pricing && product.computed_price !== product.sale_price * product.quantity)) {
      let newPrice = !product.credit ? ': $' + parseFloat(product.computed_price).toFixed(2) : '';
      let newPriceMsg = (() => {
        if (product.credit) {
          return 'Credit applied';
        } else if (hasPromo) {
          return 'Code applied';
        } else {
          return 'Bundle applied';
        }
      })();
      eNewPrice = (
        <p className='price price-new'>
          {newPriceMsg + newPrice}
        </p>
      );
    }

    const sImageSrc = '//s3.amazonaws.com/bookspan-media/covers/thumb/' + product.mmid + '.jpg';
    let lpMedallion = product.format === 'large_print' ? <img src={"/images/theme-default/lp-icon.svg"} /> : '';
    let authorName =  product.author && product.author.name ? product.author.name : "";
    return (
      <tr className="cart-item">
        <td className="col-first">
            <div className="lp-medalion">{lpMedallion}</div>
            <img src={sImageSrc} />
        </td>
        <td className="col-second">
          <p className="author">{authorName}</p>
          <p className="title">{product.title}</p>
          <p className="type"></p>
          <p className={((hasPromo && computedCart.promo) || product.credit || (product.bundle_pricing && product.computed_price !== product.sale_price * product.quantity )) && !product.credit ? 'price price-old' : 'price'}>
            {'Buy it Now: $' + salePrice}
          </p>
          {eNewPrice}
        </td>
        <td className="col-third">
            <div
                className="remove"
                onClick={() => this.props.dispatch(removeCartProduct( product ))} >
            </div>
            <div className="select-wrapper small">
              <select className="right quantity" onChange={() => {}} value={product.quantity ? product.quantity.toString() : "1"} disabled>
              { new Array(MAX_QUANTITY).fill().map( (x, i) => (<option value={i+1}>{i+1}</option>) ) }
              </select>
            </div>
        </td>
      </tr>
    );
  }
};

function mapStateToProps(state){
    return {
      'computedCart': state.computedCart
    };
}

export default connect(mapStateToProps)(ModalMiniCartItem);



// WEBPACK FOOTER //
// ./src/components/ModalMiniCartItem.jsx